import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import { Phone as PhoneIcon, CreditCard as CreditCardIcon } from '@mui/icons-material';
import apiInstance from '../../../services/ServiceApi';

const HistoricoGestionStats = ({ codigo_usuario, idLineaNegocio }) => {
  const [totalLlamadas, setTotalLlamadas] = useState(0);
  const [compromisosPagos, setCompromisosPagos] = useState(0);
  
  // Nuevos estados para getMisVentas
  const [dataMisVentas, setDataMisVentas] = useState([]);
  const [dataMisAgendas, setDataMisAgendas] = useState([]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await apiInstance.get(`/historico/stats/${codigo_usuario}/${idLineaNegocio}/`);
        const { total_llamadas, compromisos_pagos } = response.data;
        setTotalLlamadas(total_llamadas);
        setCompromisosPagos(compromisos_pagos);
      } catch (error) {
        console.error('Error al obtener estadísticas:', error);
      }
    };

    fetchStats();
  }, [codigo_usuario, idLineaNegocio]);

  // Función getMisVentas integrada
  const getMisVentas = () => {
    apiInstance.get('misVentas/', { params: { codigo_usuario, linea_negocio_id: idLineaNegocio, fecha_inicio: '2023-01-01' } })
      .then(res => {
        setDataMisVentas(res.data.venta);
        setDataMisAgendas(res.data.agenda);
      })
      .catch(err => {
        console.error('Error al obtener mis ventas:', err);
      });
  };

  // useEffect para llamar getMisVentas
  useEffect(() => {
    if (codigo_usuario && idLineaNegocio) {
      getMisVentas();
    }
  }, [codigo_usuario, idLineaNegocio]);

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={6}>
        <Grid container alignItems="center">
          <Grid item>
            <PhoneIcon fontSize="small" /> Llamadas : {totalLlamadas} 
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container alignItems="center">
          <Grid item>
            <CreditCardIcon fontSize="small" /> CP: {compromisosPagos} 
          </Grid>
        </Grid>
      </Grid>
      {/* Puedes agregar más estadísticas basadas en dataMisVentas y dataMisAgendas */}
      <Grid item xs={6}>
        <Grid container alignItems="center">
          <Grid item>
            Mis Ventas: {dataMisVentas.length}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Grid container alignItems="center">
          <Grid item>
            Mis Agendas: {dataMisAgendas.length}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HistoricoGestionStats;
